import { toast } from 'react-hot-toast';

export function useCustomToast() {
  const customToast = (type: 'success' | 'error', message: string) => {
    const text = <p className="text-body1 font-md">{message}</p>;
    switch (type) {
      case 'success':
        toast.success(text, {
          position: 'bottom-right',
          duration: 3000,
        });
        break;
      case 'error':
        toast.error(text, {
          position: 'bottom-right',
          duration: 3000,
        });
        break;
      default:
        toast(text, {
          position: 'bottom-right',
          duration: 3000,
        });
    }
  };

  return customToast;
}
